import { createContext, ReactNode, useContext } from "react";

import type { SalesContextValue } from "./SalesContext.types";

// ─── Public API ────────────────────────────────────────────────────────────────

export function useSalesContext(): SalesContextValue {
    const context = useContext(SalesContext);
    if (!context) {
        throw new Error("Component must be wrapped in SalesContextProvider");
    }
    return context;
}

export function SalesContextProvider({ value, children }: { value: SalesContextValue | null; children: ReactNode }) {
    return <SalesContext.Provider value={value}>{children}</SalesContext.Provider>;
}

// ─── Internal ──────────────────────────────────────────────────────────────────

const SalesContext = createContext<SalesContextValue | null>(null);
